import { button } from "@styled-system/recipes";
import { Container, Flex } from "@styled-system/jsx";
import { css, cx } from "@styled-system/css";
import useI18n from "@/hooks/useI18n";
import { GiftCardHeader } from "@/ui/GiftCard/GiftCardHeader";
import { GiftCardPageHeading } from "@/ui/GiftCard/GiftCardHeading";
import Link from "@/components/react/Link";
import Products from "./components/Products";
import Comparison from "./Comparison";
import environment from "@/modules/environment";

export default function Pricing({ products, countryCode }: { products: Product[]; countryCode: string }) {
  const { t } = useI18n();
  return (
    <Container mb="7rem">
      <h2 className={css({ textAlign: "center", mb: ["2rem", "3.5rem"], px: "9px" })}>{t("pricing.h1")}</h2>
      <Flex mt={["2rem", "2.5rem"]} flexDir="column">
        <Products countryCode={countryCode} products={products} />
        <Comparison />
      </Flex>
      {!environment.isCamerito && (
        <Flex flexDir="column" alignItems="center" mt="7rem">
          <GiftCardPageHeading className={css({ mb: "4.5rem" })} />
          <GiftCardHeader className={css({ maxW: "920px" })} />
          <Link href="/gift-card">
            <button
              className={cx(
                button({ variant: "filled" }),
                css({
                  mt: "3.5rem"
                })
              )}
            >
              {t("button.giveGiftCard")}
            </button>
          </Link>
        </Flex>
      )}
    </Container>
  );
}
